import { LinkedAccount } from "../../hooks/auth";
import { ACCOUNT_LABELS } from "../../utils/accountProvider";

interface Props {
  accounts: LinkedAccount[];
  loading: boolean;
  onChoose: (accountId: string) => void;
  onBack: () => void;
}

// Escolha entre a conta CDC e a conta Iugu no login. A Iugu só libera depois
// de aprovada e ativada pelo backoffice.
export function AccountChoice({ accounts, loading, onChoose, onBack }: Props) {
  return (
    <div className="mt-6 flex w-full flex-col gap-3">
      {accounts.map((linked) => {
        const opening = linked.provider === "IUGU" && linked.status !== "ACTIVE";
        return (
          <button
            key={linked.id}
            type="button"
            disabled={loading || opening}
            onClick={() => onChoose(linked.id)}
            className="flex w-full items-center justify-between rounded border border-gray-300 bg-white px-4 py-3 text-left shadow-sm hover:border-primary disabled:cursor-not-allowed disabled:opacity-60"
          >
            <span className="min-w-0">
              <span className="block font-semibold text-gray-900">
                {ACCOUNT_LABELS[linked.provider] || linked.provider}
              </span>
              <span className="block truncate text-sm text-gray-500">{linked.name}</span>
            </span>
            {opening && (
              <span className="ml-3 whitespace-nowrap text-xs font-medium text-yellow-700">
                Em abertura
              </span>
            )}
          </button>
        );
      })}
      <button
        type="button"
        onClick={onBack}
        disabled={loading}
        className="mt-2 text-sm text-gray-500 hover:underline"
      >
        Voltar
      </button>
    </div>
  );
}
